(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magazine"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".editorial-image-grid").forEach(section => {
    const track = section.querySelector(".editorial-image-track");
    const next = section.querySelector(".slider-arrow.next");
    const prev = section.querySelector(".slider-arrow.prev");

    if (!track || !next || !prev) return;

    function scrollAmount() {
      const item = track.querySelector(".editorial-image-item");
      return item ? item.offsetWidth + 14 : 300;
    }

    next.addEventListener("click", () => {
      track.scrollBy({ left: scrollAmount(), behavior: "smooth" });
    });

    prev.addEventListener("click", () => {
      track.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videosection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.editorial-video-grid').forEach(section => {

    const track = section.querySelector('.editorial-video-track');
    const prev = section.querySelector('.slider-arrow.prev');
    const next = section.querySelector('.slider-arrow.next');

    if (!track || !prev || !next) return;

    let items = Array.from(track.children);
    const visible = 4;

    if (items.length <= visible) return;

    const clonesBefore = items.slice(-visible).map(n => n.cloneNode(true));
    const clonesAfter = items.slice(0, visible).map(n => n.cloneNode(true));

    clonesBefore.forEach(c => track.prepend(c));
    clonesAfter.forEach(c => track.append(c));

    items = Array.from(track.children);
    let index = visible;
    let slideWidth;

    function measure() {
      slideWidth = items[0].offsetWidth + 24;
      track.style.transform = `translate3d(${-index * slideWidth}px,0,0)`;
    }

    measure();
    window.addEventListener('resize', measure);

    function move() {
      track.style.transform = `translate3d(${-index * slideWidth}px,0,0)`;
    }

    next.addEventListener('click', () => {
      index++;
      move();

      if (index === items.length - visible) {
        setTimeout(() => {
          track.style.transition = 'none';
          index = visible;
          move();
          track.offsetHeight;
          track.style.transition = '';
        }, 550);
      }
    });

    prev.addEventListener('click', () => {
      index--;
      move();

      if (index === 0) {
        setTimeout(() => {
          track.style.transition = 'none';
          index = items.length - visible * 2;
          move();
          track.offsetHeight;
          track.style.transition = '';
        }, 550);
      }
    });

  });
});

  } catch(e) { console.error(e); }
})();
})();
